export default "__VITE_ASSET__BgPnhBFy__"